"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
/**
 * removing locking time to order
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    let order = (0, utils_1.clone)(prevState);
    order.lock = null;
    return order;
}
exports.default = default_1;
//# sourceMappingURL=orderUnlock.js.map